var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCompassOutline = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2l.28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8l.25-.004C16.551 19.865 20 16.335 20 12l-.004-.25C19.865 7.449 16.335 4 12 4zm2.58 4.07c.383-.151.82-.052 1.1.25l.088.102c.215.283.265.665.122.998l-1.75 4.26c-.102.25-.3.448-.55.55l-4.21 1.7c-.12.048-.25.072-.38.07l-.12-.022c-.233-.057-.44-.198-.58-.398h-.05c-.237-.276-.306-.659-.18-1l1.75-4.26c.102-.25.3-.448.55-.55zm-1.38 2.72l-1.69.68-.71 1.74 1.69-.68.71-1.74z",
    transform: "translate(.625)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompassOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/compassOutline.529c12d7.svg";
export { ForwardRef as ReactComponent };